module.exports = __webpack_public_path__ + "src/assets/img/smoke_six.5680f65a.svg";